import { notify } from 'util/notify';

const OpenNotification = (option) => notify[option.type]({ message: option.title });

export default OpenNotification;
